<template>
  <div class="main">
    <div class="top">
      <div class="nr">
        <div class="toux"></div>
        <div class="xx">
          <div class="mz">{{ userInfo.userName }}</div>
          <div class="dw">{{ info.company || "暂无" }}</div>
        </div>
      </div>
    </div>
    <div class="tiao"></div>
    <div class="bot">
      <!-- <div class="time">{{ now.slice(0, 10) }} {{ sjd }}打卡</div> -->
      <div class="time">{{ info.title }}</div>
      <div class="big-btn" v-if="pass" @click="daka()">
        <div>{{ type }}</div>
        <div style="margin-top: 10px">{{ now.slice(11, 19) }}</div>
      </div>
      <div class="big-btn1" v-else>
        <div>{{ type }}</div>
        <div style="margin-top: 10px">{{ now.slice(11, 19) }}</div>
      </div>
      <div class="fanwei" v-if="pass">
        <van-icon name="checked" color="#28dabc" />
        <div class="wz">已进入规定考勤范围</div>
      </div>
      <div class="fanwei" v-else>
        <van-icon name="warning" color="#ffc017" />
        <div class="wz" style="color: grey">当前不在考勤范围内</div>
      </div>
      <div class="two">
        <div class="item">
          <div>上班时间</div>
          <div>{{ info.workPunc.ruleTime }}</div>
          <div v-if="info.workPunc.time">
            <van-icon name="passed" color="#28dabc" />
            {{info.workPunc.time}} 已打卡
          </div>
          <div v-else style="color: #ff9600">
            <van-icon name="close" color="#ff9600" />
            未打卡
          </div>
        </div>
        <div class="item">
          <div>下班时间</div>
          <div>{{ info.offPunc.ruleTime }}</div>
          <div v-if="info.offPunc.time">
            <van-icon name="passed" color="#28dabc" />
            {{info.offPunc.time}}已打卡
          </div>
          <div v-else style="color: #ff9600">
            <van-icon name="close" color="#ff9600" />
            未打卡
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const axios = require("axios");
import getwxconfig1 from "../../components/wxconfig1.js"; //微信sdk的封装js
export default {
  data() {
    return {
      userInfo: { depts: [{ deptName: "" }] },
      now: "",
      sjd: "",
      lng: "",
      lat: "",
      pass: true,
      info: {
        workPunc: {
          ruleTime: "",
          time: "",
        },
        offPunc: {
          ruleTime: "",
          time: "",
        },
      },
      type: "",
      attendanceRange:'',
      lnglat:"",
    };
  },
  created() {},
  mounted() {
    var vm = this;
    this.getData();
    getwxconfig1().then(result => {
        vm.lat=result.lat
        vm.lng=result.lng
        console.log("🚀 ~ file: index.vue:92 ~ getwxconfig1 ~ vm.lng:", vm.lng)
          // 是否在范围
          var gdAdd = vm.lnglat.split(",");
          console.log("🚀 ~ file: index.vue:98 ~ getwxconfig1 ~ gdAdd:", gdAdd)
          if ((vm.getDistance(vm.lat, vm.lng, gdAdd[1], gdAdd[0])-0) <(vm.attendanceRange-0)) {
            console.log('在范围内')
            vm.pass = true;
          } else {
            console.log('不在范围内')
            vm.pass = false;
          }


    })

    // 本地测试
    // vm.lng = "118.329508",//测试地点
    // vm.lat = "33.928012",//测试地点
    this.now = this.currTimeFormate();
    setInterval(() => {
      this.now = this.currTimeFormate();
    }, 1000);

    this.getsjd();
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  },
  methods: {
    currTimeFormate() {
      var date = new Date(); // 当前日期时间
      var year = date.getFullYear(); // 年份
      var month = ("0" + (date.getMonth() + 1)).slice(-2); // 月份+1
      var day = ("0" + date.getDate()).slice(-2); // 日
      var hour = ("0" + date.getHours()).slice(-2); // 小时
      var minute = ("0" + date.getMinutes()).slice(-2); // 分钟
      var second = ("0" + date.getSeconds()).slice(-2); // 秒数
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
      //# sourceURL=snippet:///Script%20snippet%20%233
    },
    getsjd() {
      var hours = this.now.slice(11, 13);

      if (hours >= 0 && hours <= 10) {
        this.sjd = `上午`;
      } else if (hours > 10 && hours <= 13) {
        this.sjd = `中午`;
      } else if (hours > 13 && hours <= 18) {
        this.sjd = `下午`;
      } else if (hours > 18 && hours <= 24) {
        this.sjd = `晚上`;
      }
    },
    getData() {
      var vm = this;
      this.$axios
        .get("/api/v1/wygl/workAttendace/punchClock/getInfo", {
          params: {
            //    houseId:sessionStorage.getItem('houseId'),
          },
        })
        .then((res) => {
          // console.log("🚀 ~ file: index.vue:114 ~ getData ~ res:", res);
          vm.info = res;

          var reg = RegExp(/上班/);
          if (res.title.match(reg)) {
            //包含；
            vm.type = "上班";
          } else {
            vm.type = "下班";
          }
          vm.attendanceRange=res.attendanceRange
          vm.lnglat=res.lnglat
        });
    },

    getDistance(lat1, lng1, lat2, lng2) {
      //获取经纬度距离
      const radLat1 = (lat1 * Math.PI) / 180.0;
      const radLat2 = (lat2 * Math.PI) / 180.0;
      const a = radLat1 - radLat2;
      const b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
      let s =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(radLat1) *
                Math.cos(radLat2) *
                Math.pow(Math.sin(b / 2), 2)
          )
        );
      s = s * 6378.137; 
      s = Math.round(s * 10000) / 10000;
      console.log("距离为" + s * 1000); // 米数
      return s * 1000; // 返回米数
    },

    daka() {
      // console.log("去打卡");
      var postUrl = "/api/v1/wygl/workAttendace/punchClock/punchClock?type="+ this.info.type;
      var jsonData = {
        type: this.info.type,
      };
      this.$axios.post(postUrl).then((res) => {
        console.log(res);
        this.$dialog({ message: "提交成功" }).then(() => {
          this.$router.go(-1);
        });
      });
    },
  },
};
</script>
<style lang="less">
.main {
  width: 100vw;
  height: 100vh;
  background-color: #fff;

  .top {
    width: 100%;
    height: 12%;
    .nr {
      width: 95%;
      margin: 0 auto;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .toux {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      background: url("../../assets/grzx/head.png") no-repeat;
      background-size: 100% 100%;
      border: solid 5px #2897ff;
      margin-right: 20px;
    }
    .xx {
      .mz {
        font-size: 18px;
        font-weight: bold;
      }
      .dw {
        color: gray;
      }
    }
  }
  .tiao {
    width: 100%;
    height: 9px;
    background-color: #f5f5f5;
  }
  .bot {
    width: 100%;
    height: calc(88% - 9px);
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    .time {
      font-size: 16px;
      font-weight: bold;
      color: #000;
      margin-top: 15px;
    }
    .big-btn {
      width: 145px;
      height: 145px;
      border-radius: 50%;
      border: 10px solid #eaf9ff;
      background-color: #4eaaff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #fff;
      margin-top: 15px;
    }
    .big-btn1 {
      width: 145px;
      height: 145px;
      border-radius: 50%;
      border: 10px solid #f6f6f6;
      background-color: #cfcfcf;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #fff;
      margin-top: 15px;
    }
    .fanwei {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 20px;
      margin-top: 15px;
      .wz {
        margin-left: 5px;
        font-size: 15px;
        color: #5392f6;
      }
    }
    .two {
      width: 80%;
      height: 107px;
      margin-top: 15px;
      margin: 15px auto;
      // background: #2897ff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        width: 141px;
        height: 107px;
        border-radius: 7px;
        box-shadow: 1px 1px 1px 1px lightgrey;
      }
      .item div:nth-child(1) {
        color: #b0b0b0;
      }
      .item div:nth-child(2) {
        color: #000;
        font-weight: bold;
      }
      .item div:nth-child(3) {
        color: #28dabc;
      }
    }
  }
}
</style>